<template>
  <Chip style="gap: 0" class="bg-tag-green" :style="`${styleForTag()}`">
    <span class="text-truncate">{{ getFlagDisplayString() }}</span>
    <span v-if="$slots.addition" class="ml-1">
      <slot name="addition"></slot>
    </span>
  </Chip>
</template>

<script setup lang="ts">
import { getContrastColor } from "@/functions/colorHelper";
import { useTranslation } from "@/language/translation";
import Chip from "primevue/chip";

const props = defineProps<{
  flag: {
    id?: number;
    name?: string;
    abbreviationId?: number;
    displayNameId?: number;
    color?: string;
  };
}>();

const { t, te } = useTranslation();

function styleForTag() {
  if (props.flag.color) {
    let addition = `color: ${getContrastColor(props.flag.color)};`;
    return `background-color: ${props.flag.color} !important;${addition}`;
  }
  return "color: white;";
}

function getFlagDisplayString() {
  return te(`dynamic.${props.flag.abbreviationId}`)
    ? t(`dynamic.${props.flag.abbreviationId}`)
    : te(`dynamic.${props.flag.displayNameId}`)
      ? t(`dynamic.${props.flag.displayNameId}`)
      : (props.flag.name ?? `[${t("global.id")}:${props.flag.id}]`);
}
</script>

<style lang="scss" scoped></style>
